import { OptimizelyClient, User, UserContext } from "../types";
import getUserAttributes from "./getUserAttributes";

const emptyUserContext: UserContext = {
  decide: () => null,
  trackEvent: () => null,
  setForcedDecision: () => false,
  getForcedDecision: () => null,
  getUserId: () => "",
  getAttributes: () => ({}),
  setAttribute: () => {},
  decideForKeys: () => ({}),
  decideAll: () => ({}),
  removeForcedDecision: () => false,
  removeAllForcedDecisions: () => false,
  qualifiedSegments: null,
  fetchQualifiedSegments: () => Promise.resolve(false),
  isQualifiedFor: () => false,
};

export interface OptimizelyUserContextParams {
  isFeatureExperimentation: boolean;
  optimizelyClient: OptimizelyClient;
  user: User;
  customUserAttributes?: Record<string, unknown>;
}

export const createUserContext = ({
  user,
  optimizelyClient,
  isFeatureExperimentation,
  customUserAttributes,
}: OptimizelyUserContextParams): UserContext => {
  const userContext =
    user.userId && isFeatureExperimentation
      ? optimizelyClient.createUserContext(user.userId, {
          ...getUserAttributes(user),
          ...customUserAttributes,
        })
      : emptyUserContext;

  return userContext ?? emptyUserContext;
};
